import { TabItem } from "../config";
import { getDateRangeFilter } from "./DateFormat";

export const matchMakingTabs: TabItem[] = [
    { id: 0, title: 'All', statusKey: '' },
    { id: 1, title: 'Pending ', statusKey: 'pendingServiceOffer' },
    { id: 2, title: 'In Progress ', statusKey: 'pendingServiceOffer' },
    { id: 3, title: 'Completed ', statusKey: 'pendingServiceOffer' }
];

export const matchMakingTable:any = [
  {
        name: 'Application Number',
        key: 'id'
    },
    {
        name: 'Requested Service',
        key: 'requestedService'
    },
    {
        name: 'Request Date',
        key: 'requestDate'
    },
    {
        name: 'Status',
        key: 'matchMakingStatus'
    },
    {
        name: 'Details',
        key: 'details'
    }
];

export const STATUS_FILTER_MAP: Record<number, string[]> = {
    // 1: ['qualifiedPendingInitialReview', 'pendingQualification'], // Pending
    1: [
          'needRevisionByAccountManager',
        'pendingQualificationCall',
        'qualified',
        'meetingArrangedWithRequestor'
    ], // In Progress,
     2: ['rejected', 'completed', 'disqualifiedAfterMeeting', 'disqualified'] // Completed

};

export const buildStatusFilter = (activeTab: number): string | undefined => {
    const statuses = STATUS_FILTER_MAP[activeTab];

    if (!statuses || statuses.length === 0) {
        return undefined; // All tab
    }

    return `requestorStatus in (${statuses
        .map((status) => `'${status}'`)
        .join(',')})`;
};

export const buildLiferayFilterQuery = (filters: any, active: number, userEmail:string) => {
    const filterParts: string[] = [];

    if(userEmail) {
      filterParts.push(`(requestorWorkEmail eq '${userEmail}')`);
    }

    // existing status filter (tab based)
    const statusFilter = buildStatusFilter(active);
    if (statusFilter) {
        filterParts.push(statusFilter);
    }

    // requestor status filter
    if (filters.requestorStatus?.length) {
        const values = filters.requestorFirstName
            .map((v: string) => `(requestorStatus eq '${v.split(' ')[0]}')`)
            .join(' or ');
        filterParts.push(`(${values})`);
    }

    // request date filter
    if (filters.requestDate?.length) {
        const values = filters.requestDate.map((value: any) => {
            return getDateRangeFilter(value);
        });
        filterParts.push(`(${values.join(' or ')})`);
    }


    return filterParts.length ? filterParts.join(' and ') : undefined;
};

export type FilterObject = {
    [key: string]: string[];
};

export const matchMakingFilterFields = [
    // {
    //     id: 2,
    //     label: 'Requestor Service',
    //     name: 'requestedService',
    //     required: true,
    //     type: 'multiSelect',
    //     placeholder: 'Select Requested Service',
    //     errorMessage: 'Requested Service'
    // },
    {
        id: 3,
        label: 'Request Date',
        name: 'requestDate',
        required: true,
        type: 'multiSelect',
        placeholder: 'Select Request Date',
        errorMessage: 'Request Date'
    },
    {
        id: 4,
        label: 'Status',
        name: 'requestorStatus',
        required: true,
        type: 'multiSelect',
        placeholder: 'Select Status',
        errorMessage: 'status'
    }
];